
import React from "react";
import { Loader } from "../../Common/Loader";
import {
    DDPodFormDesktopOtpSection,
    DDPodFormDesktopImageUploadSection,
} from "./DDPodFormElements";
import { FlexColumn, SushiModal } from "../../Common/styles.common";
import Breadcrumb from "components/shared/Breadcrumb/Breadcrumb";
import {
    DesktopPage,
    TitleRow as TopRow,
    TitleBlock,
    Title,
    Actions,
    ActionButton,
} from "components/core/Common/DesktopHelpers/DesktopHelpers";

// ─── Inline styled zones ────────────────────────────────────────────────────

const cardStyle = {
    background: "#ffffff",
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
};

// ─── Component ───────────────────────────────────────────────────────────────

export default function DDPodFormDesktop({
    po,
    items,
    showLoader,
    tonnage,
    errorMsg,
    otpPage,
    otp,
    setOtp,
    showError,
    openConfirmation,
    imageArray,
    previewImage,
    fileTypeErr,
    errorText,
    navigateToOtpPage,
    makeValidateOtp,
    closeConfirmation,
    handleImageInputChange,
    goToDDList,
}) {
    if (showLoader) {
        return <Loader />;
    }

    if (!po) {
        return <></>;
    }

    const purchaseOrderNumber = po.purchase_order_number;

    return (
        <DesktopPage>
            {/* Confirmation modal */}
            <SushiModal visible={openConfirmation} isCentered>
                <FlexColumn className="align-items-center p-5">
                    <img src="/logos/tick_logo.svg" height="80px" width="80px" alt="delivered" />
                    <span className="fs-22 fw-700 my-4">Order delivered</span>
                    <span
                        className="fs-14 fw-500 text-red-500"
                        style={{ cursor: "pointer" }}
                        onClick={closeConfirmation}
                    >
                        {" "}Okay
                    </span>
                </FlexColumn>
            </SushiModal>

            {/* ── TopRow: breadcrumb + title + action button ── */}
            <TopRow>
                <TitleBlock>
                    <Breadcrumb
                        items={[
                            { label: "Home" },
                            { label: "Direct Delivery", onClick: goToDDList },
                            { label: purchaseOrderNumber },
                            { label: "Mark delivered" },
                        ]}
                    />
                    <Title>{purchaseOrderNumber}</Title>
                </TitleBlock>
                <Actions>
                    <ActionButton type="button" onClick={goToDDList}>
                        Back
                    </ActionButton>
                    {otpPage ? (
                        <ActionButton
                            type="button"
                            $primary
                            onClick={makeValidateOtp}
                        >
                            Mark delivered
                        </ActionButton>
                    ) : (
                        <ActionButton
                            type="button"
                            $primary
                            onClick={navigateToOtpPage}
                        >
                            Verify with OTP
                        </ActionButton>
                    )}
                </Actions>
            </TopRow>

            {/* ── Body (single-column card) ── */}
            <div style={cardStyle}>
                {otpPage ? (
                    <DDPodFormDesktopOtpSection
                        otp={otp}
                        setOtp={setOtp}
                        showError={showError}
                        errorText={errorText}
                        openConfirmation={openConfirmation}
                        closeConfirmation={closeConfirmation}
                    />
                ) : (
                    <>
                        <div style={{ display: "flex", flexDirection: "column", marginBottom: 16 }}>
                            <span className="fs-18 fw-700">Upload delivery challan</span>
                            <span className="fs-12 fw-400 text-gray-cool" style={{ marginTop: 4 }}>
                                with signature and issue
                            </span>
                            <span className="fs-9 fw-400 text-gray-cool" style={{ marginTop: 4 }}>
                                (supported file types are .jpeg, .jpg, .png and .tiff)
                            </span>
                        </div>
                        <DDPodFormDesktopImageUploadSection
                            imageArray={imageArray}
                            previewImage={previewImage}
                            handleImageInputChange={handleImageInputChange}
                            errorMsg={errorMsg}
                            fileTypeErr={fileTypeErr}
                        />
                    </>
                )}
            </div>
        </DesktopPage>
    );
}
